import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  PLATFORM_ID,
  Inject,
} from "@angular/core";
import { Subscription } from "rxjs";
import { DataService } from "../../../@core/services/data.service";
import {
  SliderInterface,
  FieldValue,
} from "../../../@core/models/site-data.model";
import { MatDialog } from "@angular/material/dialog";
import * as Sentry from "@sentry/browser";
import { SiteModel } from "../../../@core/models/builder.model";
import { isPlatformBrowser } from "@angular/common";

@Component({
  selector: "app-slider",
  templateUrl: "./slider.component.html",
  styleUrls: ["./slider.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliderImagesMaterialComponent implements OnInit {
  // ctaFormGroup: FormGroup;
  subscription: Subscription[] = [];
  errorMessage: string;
  data: SliderInterface;
  classBuilder: string = "";
  classField: string = "";
  position: number = 0;
  sliderIndex: number = -1;
  positionField: number = undefined;
  activatePadding: boolean = false;
  test: string = "";
  imageBackground: string[] | string;
  style: string = "";
  isStock: string = "";
  formData: FieldValue[] = [];
  formValid: boolean = false;
  title;
  minHeight: string = "";
  site: SiteModel;
  timeOut;

  constructor(
    @Inject(PLATFORM_ID) public platformId,
    private dataService: DataService,
    private _cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "SliderImagesComponent");
    });
    // this.initForm();
    this.minHeight = this.data.minHeight ? this.data.minHeight : "";
    this.imageBackground = this.data.imageBackground;
    this.isStock = this.data.isStock;
    this.sliderBackgroundImage();
  }
  isString(val): boolean {
    return typeof val === "string";
  }
  sliderBackgroundImage() {
    if (typeof this.imageBackground == "string") {
      this.imageBackground = [this.imageBackground];
      this.style = `url(${this.imageBackground})`;
    } else {
      this.imageBackground;
      if (this.imageBackground.length == this.sliderIndex + 1) {
        this.sliderIndex = -1;
      }
      this.sliderIndex = this.sliderIndex + 1;
      if (this.imageBackground) {
        this.style = `url(${this.imageBackground[this.sliderIndex]})`;
      }
      this._cdr.detectChanges();
      if (isPlatformBrowser(this.platformId)) {
        if (this.imageBackground.length > 1) {
          this.timeOut = setTimeout(() => {
            this.sliderBackgroundImage();
          }, 5000);
        }
      }
    }
  }
  nextSliderClick(index: number) {
    this.sliderIndex = index;
    if (this.imageBackground) {
      this.style = `url(${this.imageBackground[this.sliderIndex]})`;
    }
    if (isPlatformBrowser(this.platformId)) {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        this.sliderBackgroundImage();
      }, 5000);
    }
  }

  updateUrl($event) {
    const src = $event.target.src;
    this.style = `url(${"https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/gallery/loading.gif"})`;
    setTimeout(() => {
      this.style = `url(${src})`;
      this.dataService.reloadModules("heroBackImage");
    }, 8000);
  }
}
